import React, { ReactNode } from 'react'
import {
  Wrapper,
  Detail,
  Profile,
  ProfileImage,
  Title,
  Description,
  Footer,
  MembershipCard,
  PrivilegeButton,
  PrivilegeText,
  CouponDesc,
} from './styled'
import { useTranslation } from 'react-i18next'

interface MembershipPrivilegeProps {
  title: string
  profileImage: string
  tierImageCard: string
  description: ReactNode
  privilegeInfo: string
  onClickPrivilegeButton: VoidFunction
}

const MembershipPrivilege = ({
  title,
  profileImage,
  tierImageCard,
  description,
  privilegeInfo,
  onClickPrivilegeButton,
}: MembershipPrivilegeProps) => {
  const { t } = useTranslation()

  return (
    <Wrapper>
      <Detail>
        <Profile>
          <ProfileImage src={profileImage} alt="" />
          <div>
            <Title>{title}</Title>
            <Description>{description}</Description>
          </div>
        </Profile>
        <MembershipCard src={tierImageCard} alt="" />
      </Detail>
      <Footer>
        <CouponDesc>
          <PrivilegeText>{privilegeInfo}</PrivilegeText>
        </CouponDesc>
        <PrivilegeButton onClick={onClickPrivilegeButton} sm>
          {t('dineIn.privilege.buttonText')}
        </PrivilegeButton>
      </Footer>
    </Wrapper>
  )
}

export default MembershipPrivilege
